import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ExtendCloseIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Group 29613218">
        <circle id="Ellipse 1191" cx="9.15088" cy="9" r="8.5" fill={fillColor || '#2B2D2E'} stroke="url(#paint0_linear_313_20736)" />
        <g id="Group 29613229">
          <rect
            id="Rectangle 41206"
            x="6.90845"
            y="7.7666"
            width="1.05882"
            height="5.29412"
            transform="rotate(-45 6.90845 7.7666)"
            fill={fillColor || 'white'}
          />
          <rect
            id="Rectangle 41207"
            x="7.66064"
            y="11.5142"
            width="1.05882"
            height="5.29412"
            transform="rotate(-135 7.66064 11.5142)"
            fill={fillColor || 'white'}
          />
        </g>
      </g>
      <defs>
        <linearGradient id="paint0_linear_313_20736" x1="9.15088" y1="-4.3869e-08" x2="6.98596" y2="14.2073" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.15" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { ExtendCloseIcon };
